import axios from "axios";
import React, { useEffect, useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { toast } from "react-hot-toast";
import EditProductModal from "../../../../../Components/Modal/ModalInventory/EditProductModal";
import AddCustomProductModal from "../../../../../Components/Modal/ModalInventory/AddCustomProductModal";
import ModalRightSidebar from "../../../../../Components/Modal/ModalInventory/ModalRightSidebar";
import AddInventoryProductModal from "../../../../../Components/Modal/ModalInventory/AddInventoryProductModal";
import AddNewSetModal from "../../../../../Components/Modal/ModalInventory/AddNewSetModal";
import { FaPlus, FaBoxOpen } from "react-icons/fa"; // Import icons from React Icons
import { Link } from "react-router-dom";
import AddDeliveryChargesModal from "../../../../../Components/Modal/ModalInventory/AddDeliveryChargesModal";
import ModalTotalDiscount from "../../../../../Components/Modal/ModalInventory/ModalTotalDiscount";
import ModalAddDeposit from "../../../../../Components/Modal/ModalInventory/ModalAddDeposit";
import ModalEditOrderContact from "../../../../../Components/Modal/ModalInventory/ModalEditOrderContact";
import ModalEditOrderVenue from "../../../../../Components/Modal/ModalInventory/ModalEditOrderVenue";
import UpdateSetModal from "../../../../../Components/Modal/ModalInventory/UpdateSetModal";
import ModalAddNotes from "../../../../../Components/Modal/ModalInventory/ModalAddNotes";
import ModalAddDelivaryCharges from "../../../../../Components/Modal/ModalInventory/ModalAddDelivaryCharges";
import Swal from "sweetalert2";
import DropdownAction from "../../../../../Components/Modal/ModalInventory/DropdownAction";
import ActionProductModal from "../../../../../Components/Modal/ModalInventory/ActionProductModal";
import noImage from "./../../../../../assest/icon/no-image.png";
import AddTermsConditionsModal from "../../../../../Components/Modal/ModalInventory/AddTermsConditionsModal";
import AddTearDownFees from "../../../../../Components/Modal/ModalInventory/AddTearDownFees";
import ModalImageGallary from "../../../../../Components/Modal/ModalImageGallary";
import {
  SortableContainer,
  SortableElement,
  SortableHandle,
  arrayMove,
} from "react-sortable-hoc";
import { GripVertical } from "lucide-react";

import './pdfConvert.css';

const DragHandle = SortableHandle(() => (
  <div 
    className="cursor-move px-2 text-gray-500 hover:text-gray-700"
    onMouseDown={(e) => e.stopPropagation()} // Prevent text selection during drag
  >
    <GripVertical size={18} />
  </div>
));


const SortableItem = SortableElement(
  ({
    product,
    style,
    calculateDiscountSelectedPrice,
    calculateWithDiscountPrice,
    calculateSingleTotalPrice,
    calculateProductDiscountPrice,
    calculateTotalTaxAmount,
    calculateTotalPrice,
    handleActionProduct,
    handleEditProduct,
    perSet,
  }) => (
    <tr
    className="border-b dark:bg-gray-800 dark:border-gray-700 bg-white hover:bg-gray-50 transition-colors"
    style={{
      ...style,
      transition: "all 150ms ease",
      zIndex: "auto",
    }}
  >
    {/* Drag Handle Column - made more prominent */}
    {/* <td className="px-2 py-4 text-md">
      <DragHandle />
    </td> */}

      {/* Image and Details */}
      <td className="px-6 py-4 text-md font-roboto text-gray-800 w-[500px]">
        <div className="flex flex-row gap-2">
          <div className="w-28 h-28">
            {product?.deliveryType === "delivery" ? (
              <img
                alt=""
                className="w-28 h-28 rounded object-cover"
                src="data:image/svg+xml;base64,..."
              />
            ) : product.singleImage ? (
              <img
                className="w-28 h-28 rounded object-cover"
                src={product.singleImage}
                alt="Product"
              />
            ) : (
              <img className="w-24 h-24" src={noImage} alt="No image" />
            )}
          </div>
          <div>
            <strong>{product?.title}</strong>
            {product?.deliveryType === "delivery" ||
            product?.deliveryType === "tear" ? (
              <h1>
                {product?.deliveryType === "tear" ? null : (
                  <>
                    Start Date:{" "}
                    {new Date(product.startDate).toLocaleString("en-US", {
                      month: "short",
                      day: "numeric",
                      year: "numeric",
                      hour: "numeric",
                      minute: "2-digit",
                      hour12: true,
                    })}
                  </>
                )}
              </h1>
            ) : (
              <h1>Product Code | {product.productCode}</h1>
            )}
          </div>
        </div>
        <div className="flex flex-col gap-2 w-full mt-2">
          <span className="text-justify">
            <strong>Des</strong>: {product?.description}
          </span>
          <span className="text-justify">
            {product?.color && /\d/.test(product.color)
              ? `Color: ${product.color}, `
              : ""}
            {product?.height && /\d/.test(product.height)
              ? `Height: ${product.height}, `
              : ""}
            {product?.length && /\d/.test(product.length)
              ? `Length: ${product.length}, `
              : ""}
            {product?.width && /\d/.test(product.width)
              ? `Width: ${product.width}, `
              : ""}
            {product?.shape && /\d/.test(product.shape)
              ? `Shape: ${product.shape}`
              : ""}
          </span>
          <span className="text-justify">
            <strong>Notes</strong>: {product?.internalNotes}
          </span>
        </div>
      </td>

      {/* Quantity */}
      {product?.deliveryType === "delivery" ||
      product?.deliveryType === "tear" ? (
        <td></td>
      ) : (
        <td className="px-6 py-4 text-md font-roboto text-gray-800">
          {product?.quantity}
        </td>
      )}

      {/* Discount Price */}
      {product?.deliveryType === "delivery" ? (
        <td></td>
      ) : (
        <td className="px-6 py-4 text-md font-roboto text-gray-800">
          <div className="flex flex-col">
            <span>{calculateDiscountSelectedPrice(product)}</span>
            {product.discount && (
              <del className="mt-1">{product?.selectedPricingValue}</del>
            )}
          </div>
        </td>
      )}

      {/* With Discount Price */}
      <td className="px-6 py-4 text-md font-roboto text-gray-800">
        <div>{calculateWithDiscountPrice(product)}</div>
        {product.discount && (
          <del className="mt-1">{calculateSingleTotalPrice(product)}</del>
        )}
      </td>

      {/* Discount Info */}
      <td className="px-6 py-4 text-md font-roboto text-gray-800">
        <div className="flex flex-col gap-1">
          <span>
            {product?.discount &&
              (product?.discountType === "$" ? (
                <>
                  {product?.discountType}
                  {product?.discount}
                </>
              ) : (
                <>
                  {product?.discount}
                  {product?.discountType}
                </>
              ))}
          </span>
          {product?.discount && (
            <span className="text-sm text-red-600">
              $ ({calculateProductDiscountPrice(product)})
            </span>
          )}
        </div>
      </td>

      {/* Tax Info */}
      <td className="px-2 py-4 text-md font-roboto text-gray-800">
        {product?.tax && (
          <div className="flex flex-col items-center">
            <span>{product?.tax} %</span>
            <span className="text-red-600 text-sm">
              ($ {calculateTotalTaxAmount(product)})
            </span>
          </div>
        )}
      </td>

      {/* Final Price */}
      <td className="px-6 py-4 text-md font-roboto text-gray-800">
        {product?.discount || product?.tax ? (
          <span>{calculateTotalPrice(product)}</span>
        ) : (
          <span>
            {(product.quantity * product.selectedPricingValue).toFixed(2)}
          </span>
        )}
      </td>

      {/* Actions */}
      <td
        className="px-6 py-4 text-md font-roboto text-gray-800"
        onClick={(e) => {
          // Prevent drag initiation when clicking on actions
          e.stopPropagation();
          e.preventDefault();
        }}
      >
        <DropdownAction
          onActionClick={() => handleActionProduct(product, perSet.setCode)}
          onEditClick={() => handleEditProduct(product, perSet.setCode)}
        ></DropdownAction>
      </td>
    </tr>
  )
);

// Sortable list (the table body)
const SortableList = SortableContainer(({ items, ...props }) => (
  <tbody>
    {items.map((product, index) => (
      <SortableItem
        key={`item-${product.productId || index}`}
        index={index}
        product={product}
        {...props}
      />
    ))}
  </tbody>
));

const OrderModify = ({ products }) => {
  const allSet = products?.set || [];
  const orderId = products._id;

  const [newSetTitle, setNewSetTitle] = useState("");
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);

  // Modal State
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [editedTitle, setEditedTitle] = useState("");
  const [editedQuantity, setEditedQuantity] = useState(1);
  const [editedPrice, setEditedPrice] = useState("");
  const personEmail = products?.email;

  const [paymentData, setPaymentData] = useState([]);
  const [error, setError] = useState(null);
  const [totalPayAmount, setTotalPayAmount] = useState(0);

  const handleAddSet = async (newSet) => {
    if (!newSet.setTitle || !newSet.startDate || !newSet.endDate) {
      toast.error("Please provide a title, start date, and end date.");
      return;
    }

    try {
      // Show confirmation before adding the set
      const result = await Swal.fire({
        title: "Are you sure?",
        text: "Do you want to add this new set?",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#28a745",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, add it!",
        cancelButtonText: "No, cancel",
      });

      if (!result.isConfirmed) {
        return;
      }

      const response = await axios.put(
        `https://server-gs.vercel.app/sets/${orderId}`,
        { set: newSet }
      );

      if (response.status === 200) {
        Swal.fire({
          title: "Success!",
          text: "Product uploaded successfully.",
          icon: "success",
          timer: 400, // Auto-close after 1.5 seconds
          timerProgressBar: true, // Show progress bar
          showConfirmButton: false, // Hide "OK" button
        });

        setNewSetTitle("");
        setStartDate(null);
        setEndDate(null);
        setIsAddNewSetModalOpen(false);
      }
    } catch (error) {
      toast.error("Error adding new set.");
    }
  };

  const handleDeleteSet = async (setCode) => {
    try {
      const result = await Swal.fire({
        title: "Are you sure?",
        text: "This action cannot be undone. Do you really want to delete this set?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
        confirmButtonText: "Yes, delete it!",
        cancelButtonText: "No, cancel",
      });

      // If the user cancels, exit the function
      if (!result.isConfirmed) {
        return;
      }

      const response = await axios.delete(
        `https://server-gs.vercel.app/sets/${orderId}/${setCode}`
      );

      if (response.status === 200) {
        Swal.fire({
          title: "Deleted!",
          text: "The set has been deleted successfully.",
          icon: "success",
          timer: 400, // Auto-close after 1.5 seconds
          timerProgressBar: true, // Show progress bar
          showConfirmButton: false, // Hide "OK" button
        });
      }
    } catch (error) {
      Swal.fire({
        title: "Error",
        text: "Failed to delete the set.",
        icon: "error",
        timer: 2000, // Auto-close after 2 seconds
        timerProgressBar: true,
        showConfirmButton: false,
      });
    }
  };

  const [isModalOpenSetUpdate, setIsModalOpenSetUpdate] = useState(false);
  const [selectedSet, setSelectedSet] = useState(null);

  const handleUpdateSet = (setCode, updatedData) => {
    // Make an API call to update the set
    fetch(`https://server-gs.vercel.app/update-sets/${setCode}/${orderId}`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(updatedData), // Pass the updated data, including setTitle
    })
      .then((response) => response.json())
      .then((data) => {
        Swal.fire({
          title: "Success!",
          text: "Section updated successfully.",
          icon: "success",
          timer: 1500, // Auto-close after 1.5 seconds
          showConfirmButton: false, // No "OK" button
        });
      })
      .catch((error) => {
        console.error("Error updating set:", error);
      });
  };

  // Open Modal for Editing a Product
  const openEditModal = (product, setCode) => {
    setSelectedProduct({ ...product, setCode });
    setEditedTitle(product.title);
    setEditedQuantity(product.quantity);
    setEditedPrice(product.selectedPricingValue);
    setIsModalOpen(true);
  };

  const [IsDeposit, setIsDeposit] = useState(false); // Modal visibility state

  const openModalDeposit = () => {
    setIsDeposit(true); // Show the modal
  };
  const [IsDiscount, setIsDiscount] = useState(false); // Modal visibility state

  const openModalDiscount = () => {
    setIsDiscount(true); // Show the modal
  };

  const closeModalDiscount = () => {
    setIsDiscount(false); // Hide the modal
    setSelectedProduct(null); // Clear the selected product
  };
  const closeModalDeposit = () => {
    setIsDeposit(false); // Hide the modal
    setSelectedProduct(null); // Clear the selected product
  };

  // Save Edited Product
  //   const [selectedProduct, setSelectedProduct] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);
  const [actionProduct, setActionProduct] = useState({
    title: "",
    quantity: "",
    tax: "",
    discount: "",
    discountType: "",
  });

  const [MainSelectedSetCode, setMainSelectedSetCode] = useState(null);
  const [MainSelectedProductCode, setMainSelectedProductCode] = useState(null);
  // Open modal and load product details
  const handleActionProduct = (product, setCode) => {
    setSelectedProduct({ ...product, setCode });
    setMainSelectedProductCode(product);
    setMainSelectedSetCode(setCode);

    setActionProduct({
      title: product.title || "",
      quantity: product.quantity || "",
      tax: product.tax || "",
      discount: product.discount || "",
      discountType: product.discountType || "%",
    });
    setModalOpen(true);
  };

  // Handle input change
  const handleChange = (e) => {
    const { name, value } = e.target;
    setActionProduct((prev) => ({ ...prev, [name]: value }));
  };

  // Save Edited Product
  //   const [selectedProduct, setSelectedProduct] = useState(null);
  const [modalEditOpen, setModalEditOpen] = useState(false);

  const [editProduct, setEditProduct] = useState({
    title: "",
    quantity: "",
    description: "",
    internalNotes: "",
    singleImage: "",
  });
  const [singleImage, setSingleImage] = useState(null);
  const [isDragging, setIsDragging] = useState(false);

  const handleDragOver = (e) => {
    e.preventDefault();
    setIsDragging(true);
  };

  const handleDragLeave = () => {
    setIsDragging(false);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setIsDragging(false);
    const file = e.dataTransfer.files[0];
    setSingleImage(file);
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    setSingleImage(file);
  };

  const handleUpdateEditProduct = async () => {
    if (!selectedProduct) return;

    const { setCode, productId } = selectedProduct;

    try {
      const formData = new FormData();
      formData.append("title", editProduct.title);
      formData.append("quantity", editProduct.quantity);
      formData.append("description", editProduct.description);
      formData.append("internalNotes", editProduct.internalNotes);
      formData.append("selectedPricingValue", editProduct.selectedPricingValue);
      if (singleImage) {
        formData.append("singleImage", singleImage);
      }

      const response = await axios.put(
        `https://server-gs.vercel.app/edit-custom-products/${orderId}/${setCode}/${productId}`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      if (response.status === 200) {
        Swal.fire({
          title: "Success!",
          text: "Product updated successfully.",
          icon: "success",
          timer: 1500,
          showConfirmButton: false,
        });
        setModalOpen(false);
        setSelectedProduct(null);
      }
    } catch (error) {
      toast.error("Error updating product.");
    }
  };

  // Open modal and load product details
  const handleEditProduct = (product, setCode) => {
    setSelectedProduct({ ...product, setCode });
    setMainSelectedProductCode(product);
    setMainSelectedSetCode(setCode);

    setEditProduct({
      title: product.title || "",
      quantity: product.quantity || "",
      description: product.description || "",
      internalNotes: product.internalNotes || "",
      selectedPricingValue: product.selectedPricingValue || "",
      singleImage: product.singleImage || "",
    });
    setModalEditOpen(true);
  };

  const handleEditChange = (e) => {
    const { name, value } = e.target;
    setEditProduct((prev) => ({ ...prev, [name]: value }));
  };

  // Submit edited product
  const handleUpdateProduct = async () => {
    if (!selectedProduct) return;

    const { setCode, productId } = selectedProduct;

    try {
      const response = await axios.put(
        `https://server-gs.vercel.app/products/${orderId}/${setCode}/${productId}`,
        actionProduct
      );

      if (response.status === 200) {
        Swal.fire({
          title: "Success!",
          text: "Product updated successfully.",
          icon: "success",
          timer: 1500, // Auto-close after 1.5 seconds
          showConfirmButton: false, // No "OK" button
        });
        setModalOpen(false);
        setSelectedProduct(null);
      }
    } catch (error) {
      toast.error("Error updating product.");
    }
  };

  // Modal States
  const [isAddProductModalOpen, setIsAddProductModalOpen] = useState(false);
  const [isAddDeliveryModalOpen, setIsAddDeliveryModalOpen] = useState(false);
  const [isAddTearDownModalOpen, setIsAddTearDownModalOpen] = useState(false);
  const [isAddInventoryModalOpen, setIsAddInventoryModalOpen] = useState(false);
  const [selectedSetCode, setSelectedSetCode] = useState("");
  const [isAddNewSetModalOpen, setIsAddNewSetModalOpen] = useState(false);
  const [isAddTermsConditionsOpen, setAddTermsConditionsOpen] = useState(false);

  const handleAddProductToSet = async (setCode, newProduct) => {
    try {
      const response = await axios.post(
        `https://server-gs.vercel.app/add-inventory-custom-product/${orderId}/${setCode}/products`,
        newProduct
      );
      if (response.status === 200) {
        Swal.fire({
          title: "Success!",
          text: "Product added successfully.",
          icon: "success",
          timer: 1500, // Auto-close after 1.5 seconds
          showConfirmButton: false, // No "OK" button
        });
      }
    } catch (error) {
      toast.error("Error adding product.");
    }
  };

  const handleAddProductToSetCustom = async (orderId, setCode, newProduct) => {
    try {
      const response = await axios.post(
        `https://server-gs.vercel.app/api/add-custom-product/${orderId}/${setCode}/products`,
        newProduct,
        {
          headers: {
            "Content-Type": "multipart/form-data", // Ensure proper content type for file uploads
          },
        }
      );
      if (response.status === 200) {
        setIsAddProductModalOpen(false);
        Swal.fire({
          title: "Success!",
          text: "Product added successfully.",
          icon: "success",
          timer: 1500, // Auto-close after 1.5 seconds
          showConfirmButton: false, // No "OK" button
        });
      }
    } catch (error) {
      toast.error("Error adding product.");
    }
  };

  const handleDeleteProduct = async (setCode, productId) => {
    try {
      const result = await Swal.fire({
        title: "Are you sure?",
        text: "This action cannot be undone. Do you really want to delete this set?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
        confirmButtonText: "Yes, delete it!",
        cancelButtonText: "No, cancel",
      });

      // If user cancels, exit function
      if (!result.isConfirmed) {
        return;
      }

      const response = await axios.delete(
        `https://server-gs.vercel.app/delete-product/${orderId}/${setCode}/${productId}`
      );
      if (response.status === 200) {
        Swal.fire({
          title: "Deleted!",
          text: "The set has been deleted successfully.",
          icon: "success",
          timer: 1500, // Auto-close after 1.5 seconds
          showConfirmButton: false,
        });
      }
    } catch (error) {
      toast.error("Error deleting product.");
    }
  };

  const [isAddProducts, setIsAddProducts] = useState(false);
  const openModalAddProducts = () => {
    setIsAddProducts(true);
  };

  const closeModalAddProducts = () => {
    setIsAddProducts(false);
  };

  // calculated part
  // calculated part
  // calculated part
  const calculateDiscountSelectedPrice = (pro) => {
    let price = pro.selectedPricingValue;

    // Apply discount first
    if (pro?.discount) {
      const discountValue =
        pro.discountType === "%"
          ? (parseFloat(pro.discount) / 100) * price
          : parseFloat(pro.discount);

      price -= discountValue;
    }

    // Ensure total is not negative
    return Math.max(0, price).toFixed(2);
  };

  const calculateSingleTotalPrice = (pro) => {
    if (!pro || typeof pro !== "object") return "0.00";

    const quantity = Number(pro.quantity) || 0;
    const price = Number(pro.selectedPricingValue) || 0;

    const total = quantity * price;

    return total > 0 ? total.toFixed(2) : "0.00";
  };

  const calculateWithDiscountPrice = (pro) => {
    let priceAfterDiscount = pro.selectedPricingValue;

    // Apply discount to the selectedPricingValue first
    if (pro?.discount) {
      const discountValue =
        pro.discountType === "%"
          ? (parseFloat(pro.discount) / 100) * priceAfterDiscount
          : parseFloat(pro.discount);

      priceAfterDiscount -= discountValue;
    }

    // Multiply the discounted price by the quantity
    let total = pro.quantity * priceAfterDiscount;

    // Ensure total is not negative
    return Math.max(0, total).toFixed(2);
  };

  const calculateTotalPrice = (pro) => {
    // Convert all numerical values to numbers
    const price = parseFloat(pro.selectedPricingValue) || 0;
    const quantity = parseInt(pro.quantity) || 1;

    let priceAfterDiscount = price;

    // Apply discount if exists
    if (pro?.discount) {
      const discountAmount = parseFloat(pro.discount) || 0;
      const discountValue =
        pro.discountType === "%"
          ? (discountAmount / 100) * priceAfterDiscount
          : discountAmount;

      priceAfterDiscount = Math.max(0, priceAfterDiscount - discountValue);
    }

    // Calculate subtotal
    let total = quantity * priceAfterDiscount;

    // Add tax if exists
    if (pro?.tax) {
      const taxRate = parseFloat(pro.tax) || 0;
      const taxValue = (taxRate / 100) * total;
      total += taxValue;
    }

    return Math.max(0, total).toFixed(2);
  };
  const calculateTotalTaxAmount = (pro) => {
    // Convert all numerical values to numbers
    const price = parseFloat(pro.selectedPricingValue) || 0;
    const quantity = parseInt(pro.quantity) || 1;

    let priceAfterDiscount = price;

    // Apply discount if exists
    if (pro?.discount) {
      const discountAmount = parseFloat(pro.discount) || 0;
      const discountValue =
        pro.discountType === "%"
          ? (discountAmount / 100) * priceAfterDiscount
          : discountAmount;

      priceAfterDiscount = Math.max(0, priceAfterDiscount - discountValue);
    }

    // Calculate subtotal (after discount)
    const subtotal = quantity * priceAfterDiscount;

    // Calculate tax amount if tax exists
    if (pro?.tax) {
      const taxRate = parseFloat(pro.tax) || 0;
      return ((taxRate / 100) * subtotal).toFixed(2);
    }

    return "0.00"; // Return 0 if no tax
  };

  const calculateSubTotalPrice = (pro) => {
    return pro.quantity * pro.selectedPricingValue;
  };

  const calculateSetSubTotal = (products) => {
    return products
      .reduce((acc, pro) => acc + calculateSubTotalPrice(pro), 0)
      .toFixed(2);
  };

  const calculateSetTotal = (products) => {
    return products
      .reduce((acc, pro) => acc + parseFloat(calculateTotalPrice(pro)), 0)
      .toFixed(2);
  };

  const calculateDiscountTotal = (products) => {
    return products
      .reduce((acc, pro) => {
        if (pro?.discount) {
          let discountValue = 0;

          if (pro.discountType === "%") {
            // For percentage discount, calculate based on the subtotal
            const subtotal = pro.quantity * pro.selectedPricingValue;
            discountValue = (parseFloat(pro.discount) / 100) * subtotal;
          } else if (pro.discountType === "$") {
            // For fixed amount discount, apply the discount directly (do not multiply by quantity)
            discountValue = parseFloat(pro.discount);
          }

          acc += discountValue; // Accumulate the discount value
        }
        return acc;
      }, 0)
      .toFixed(2); // Return the total discount rounded to 2 decimal places
  };

  const calculateAllDiscountTotal = (products) => {
    return products
      .reduce((acc, pro) => {
        // Calculate the total price without discount
        const totalWithoutDiscount = parseFloat(calculateSingleTotalPrice(pro));

        // Calculate the total price with discount
        const totalWithDiscount = parseFloat(calculateWithDiscountPrice(pro));

        // Calculate the discount for this product
        const discount = totalWithoutDiscount - totalWithDiscount;

        // Add the discount to the accumulator
        return acc + discount;
      }, 0)
      .toFixed(2); // Return the total discount rounded to 2 decimal places
  };

  const calculateProductDiscountPrice = (pro) => {
    const totalWithoutDiscount = parseFloat(calculateSingleTotalPrice(pro));
    const totalWithDiscount = parseFloat(calculateWithDiscountPrice(pro));

    // Calculate the difference
    const discountAmount = totalWithoutDiscount - totalWithDiscount;

    // Ensure the discount amount is not negative
    return Math.max(0, discountAmount).toFixed(2);
  };

  // Function to calculate total tax
  const calculateTaxTotal = (products) => {
    return products
      .reduce((totalTax, product) => {
        // Get base price or default to 0
        const price = parseFloat(product.selectedPricingValue) || 0;
        const quantity = parseInt(product.quantity) || 1;

        // Apply discount if exists
        let priceAfterDiscount = price;
        if (product?.discount) {
          const discountAmount = parseFloat(product.discount) || 0;
          const discountValue =
            product.discountType === "%"
              ? (discountAmount / 100) * priceAfterDiscount
              : discountAmount;
          priceAfterDiscount = Math.max(0, priceAfterDiscount - discountValue);
        }

        // Calculate subtotal after discount
        const subtotal = quantity * priceAfterDiscount;

        // Calculate tax for this product if tax exists
        const productTax = product?.tax
          ? (parseFloat(product.tax) / 100) * subtotal
          : 0;

        return totalTax + productTax;
      }, 0)
      .toFixed(2);
  };

  const calculateAllSetSubTotal = (allSet) => {
    return allSet
      .reduce((total, perSet) => {
        // Calculate the subtotal for each set, using the correct array of products
        const setTotal = parseFloat(calculateSetSubTotal(perSet.products)); // Fix here
        return total + setTotal;
      }, 0)
      .toFixed(2);
  };

  const calculateAllSetTotal = (allSet) => {
    return allSet
      .reduce((total, perSet) => {
        const setTotal = perSet.products.reduce(
          (acc, pro) => acc + parseFloat(calculateTotalPrice(pro)),
          0
        );
        return total + setTotal;
      }, 0)
      .toFixed(2);
  };

  const calculateAllSetDiscount = (allSet) => {
    return allSet
      .reduce((total, perSet) => {
        const setDiscount = perSet.products.reduce((acc, pro) => {
          return acc + parseFloat(calculateProductDiscountPrice(pro));
        }, 0);

        return total + setDiscount;
      }, 0)
      .toFixed(2); // Round to 2 decimal places
  };

  // Function to calculate All Set Tax
  const calculateAllSetTax = (allSet) => {
    return allSet
      .reduce((totalSetsTax, perSet) => {
        // Calculate tax for all products in this set
        const setTax = perSet.products.reduce(
          (productTaxAccumulator, product) => {
            // Get base price or default to 0
            const price = parseFloat(product.selectedPricingValue) || 0;
            const quantity = parseInt(product.quantity) || 1;

            // Apply discount if exists
            let priceAfterDiscount = price;
            if (product?.discount) {
              const discountAmount = parseFloat(product.discount) || 0;
              const discountValue =
                product.discountType === "%"
                  ? (discountAmount / 100) * priceAfterDiscount
                  : discountAmount;
              priceAfterDiscount = Math.max(
                0,
                priceAfterDiscount - discountValue
              );
            }

            // Calculate subtotal after discount
            const subtotal = quantity * priceAfterDiscount;

            // Calculate tax for this product if tax exists
            return (
              productTaxAccumulator +
              (product?.tax ? (parseFloat(product.tax) / 100) * subtotal : 0)
            );
          },
          0
        );

        return totalSetsTax + setTax;
      }, 0)
      .toFixed(2); // Total tax for all sets
  };

  const calculateFinalTotal = (allSet, products) => {
    // Calculate the total for all sets
    const total = calculateAllSetTotal(allSet);

    // Get the discount value and type
    const discount = parseFloat(products?.AllProductDiscount) || 0;
    const discountType = products?.AllProductDiscountType;

    let finalTotal = parseFloat(total);

    // Apply discount based on the discount type
    if (discountType === "$") {
      // Subtract fixed amount discount
      finalTotal -= discount;
    } else if (discountType === "%") {
      // Subtract percentage discount
      finalTotal -= (discount / 100) * finalTotal;
    }

    // Ensure the final total is not negative
    return Math.max(0, finalTotal).toFixed(2);
  };

  const twentyPrcCalculateFinalTotal = (allSet, products) => {
    // Calculate the final total using the existing function
    const finalTotal = parseFloat(calculateFinalTotal(allSet, products));

    // Calculate 20% of the final total
    const twentyPercentTotal = 0.2 * finalTotal;

    // Ensure the result is not negative and format it to 2 decimal places
    return Math.max(0, twentyPercentTotal).toFixed(2);
  };

  const twentyPercentTotal = twentyPrcCalculateFinalTotal(allSet, products);

  const calculateDeposit = (
    finalTotal,
    advanceDepositValue,
    advanceDepositType
  ) => {
    if (!advanceDepositValue || !advanceDepositType || isNaN(finalTotal)) {
      return "0.00"; // Default to 0 if inputs are invalid
    }

    let depositAmount = 0;

    if (advanceDepositType === "%") {
      // If the deposit type is percentage, calculate based on finalTotal
      depositAmount =
        (parseFloat(advanceDepositValue) / 100) * parseFloat(finalTotal);
    } else if (advanceDepositType === "$") {
      // If the deposit type is fixed dollar amount, use the given value
      depositAmount = parseFloat(advanceDepositValue);
    }

    // Ensure depositAmount is not negative and format it to 2 decimal places
    return Math.max(0, depositAmount).toFixed(2);
  };

  const calculateAmountDue = (allSet, products, totalPayAmount) => {
    const finalTotal = parseFloat(calculateFinalTotal(allSet, products)); // Call the function
    return (finalTotal - totalPayAmount).toFixed(2); // Subtract totalPayAmount
  };

  // Example usage:
  const amountDue = calculateAmountDue(allSet, products, totalPayAmount);

  // send email

  const [emailData, setEmailData] = useState({
    subject: "Your Invoice from My Color Events & Design LLC",
  });
  const [loading, setLoading] = useState(false); // To show loading state
  const [message, setMessage] = useState(""); // To show success/error messages

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Show confirmation dialog first
    const result = await Swal.fire({
      title: 'Are you sure?',
      text: "You are about to send the invoice email to the customer.",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, send it!',
      cancelButtonText: 'Cancel'
    });
  
    // If user cancels, don't proceed
    if (!result.isConfirmed) {
      return;
    }
  
    // Proceed with the original logic if confirmed
    setLoading(true);
    setMessage("");
  
    try {
      const toEmail = products?.email; // Recipient email
      const orderId = products?._id; // Order ID
  
      if (!toEmail || !orderId) {
        alert("Recipient email or order ID is missing.");
        setLoading(false);
        return;
      }
  
      // Prepare dynamic invoice link
      const invoiceLink = `https://mycoloreventscloud.com/invoice/view-invoice/${orderId}`;
  
      // Send email using your backend
      const emailResponse = await axios.post(
        "https://server-gs.vercel.app/send-mail",
        {
          to: toEmail,
          subject: emailData.subject,
          link: invoiceLink,
        }
      );
  
      if (emailResponse.status === 200) {
        Swal.fire({
          title: "Success!",
          text: "Sent email successfully.",
          icon: "success",
          timer: 1500, // Auto-close after 1.5 seconds
          showConfirmButton: false, // No "OK" button
        });
  
        // Update order status to "sent"
        const updateResponse = await axios.put(
          `https://server-gs.vercel.app/admin/orders/sent/${orderId}`
        );
  
        if (
          updateResponse.status === 200 &&
          updateResponse.data.modifiedCount > 0
        ) {
          setMessage("Order position updated to 'sent' successfully!");
        } else {
          setMessage("Failed to update the order position.");
        }
      } else {
        setMessage("Failed to send email.");
      }
    } catch (error) {
      console.error("Error during handleSubmit:", error);
      setMessage("An error occurred while sending the email.");
    } finally {
      setLoading(false);
    }
  };

  // payment data start

  // edit contact

  const [isDropdownEditContact, setIsDropdownContact] = useState(false);

  const openModalEditContact = () => {
    setIsDropdownContact(true);
  };

  const closeModalEditContact = () => {
    setIsDropdownContact(false);
  };

  // edit venue

  const [isDropdownEditVenue, setIsDropdownVenue] = useState(false);

  const openModalEditVenue = () => {
    setIsDropdownVenue(true);
  };

  const closeModalEditVenue = () => {
    setIsDropdownVenue(false);
  };

  // edit notes

  const [isDropdownEditNotes, setIsDropdownNotes] = useState(false);

  const openModalEditNotes = () => {
    setIsDropdownNotes(true);
  };

  const closeModalEditNotes = () => {
    setIsDropdownNotes(false);
  };

  const [images, setImages] = useState([]); // For multiple images
  useEffect(() => {
    setImages(products.images || []);
  }, []);

  const invoicePaymentId = products?.paymentId;

  useEffect(() => {
    if (personEmail && invoicePaymentId) {
      const fetchPaymentData = async () => {
        try {
          const response = await axios.get(
            `https://server-gs.vercel.app/paid/stripe/${personEmail}/${invoicePaymentId}`
          );
          setPaymentData(response.data);

          // Calculate the total payAmount if available
          const total = response.data.reduce(
            (acc, payment) => acc + (parseFloat(payment.payAmount) || 0),
            0
          );
          setTotalPayAmount(total?.toFixed(2)); // Ensure two decimal places
        } catch (err) {
          console.error("Error fetching payment data:", err);
          setError("Failed to fetch payment data");
        }
      };

      fetchPaymentData();
    }
  }, [personEmail, invoicePaymentId]);

  const [data, setData] = useState(null);
  const [selectedOption, setSelectedOption] = useState("");
  const [isUserSelected, setIsUserSelected] = useState(false); // Track if user has manually selected an option

  const dataTermsConditions = products.termsConditions;

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(
          "https://server-gs.vercel.app/event-company-profile"
        );
        setData(response.data);
        setError(null); // Clear any previous errors

        // Only set the default option if the user hasn't manually selected an option
        if (response.data) {
          const matchedField = Object.keys(response.data).find(
            (key) => key === dataTermsConditions
          );

          // If a match is found, set the matched field as the default
          if (matchedField) {
            setSelectedOption(matchedField);
          }
        }
      } catch (err) {
        setError(err.message || "Something went wrong");
      } finally {
        setLoading(false);
      }
    };

    // Fetch data every second
    const intervalId = setInterval(fetchData, 1000);

    // Cleanup the interval on component unmount
    return () => clearInterval(intervalId);
  }, [dataTermsConditions]); // Add isUserSelected as a dependency

  const renderSelectedContent = () => {
    if (!data) return null;

    // If selectedOption matches a field in data, return its value
    if (selectedOption && data[selectedOption]) {
      return data[selectedOption];
    }

    // If dataTermsConditions matches a field in data, return its value as default
    if (dataTermsConditions && data[dataTermsConditions]) {
      return data[dataTermsConditions];
    }

    // Fallback if no match is found
    return "Please select an option.";
  };

  const [sets, setSets] = useState(allSet || []);

  const handleSortEnd = async (setCode, { oldIndex, newIndex }) => {
    if (oldIndex === newIndex) return;

    const updatedSets = sets.map((perSet) => {
      if (perSet.setCode === setCode) {
        const updatedProducts = arrayMove(perSet.products, oldIndex, newIndex);
        return { ...perSet, products: updatedProducts };
      }
      return perSet;
    });

    setSets(updatedSets);
    setLoading(true);
    setError("");

    try {
      await axios.put(`https://server-gs.vercel.app/handle-sort/${orderId}`, {
        sets: updatedSets,
      });
    } catch (err) {
      setError("Failed to update sort order. Please try again.");
      console.error("Sort update failed:", err);
      // Optionally revert the state if the API call fails
      setSets(sets);
    } finally {
      setLoading(false);
    }
  };

  const [isLoading, setIsLoading] = useState(false);

  const updatePaymentInBackend = async () => {
    if (!orderId) return;

    setIsLoading(true);
    setError(null);

    try {
      const totalAmount = calculateFinalTotal(allSet, products);
      const amountDue = calculateAmountDue(allSet, products, totalPayAmount);

      await axios.put('https://server-gs.vercel.app/add-payment-history', {
        orderId,
        totalAmount,
        amountPaid: totalPayAmount,
        amountDue
      });

      console.log('Payment updated successfully');
    } catch (err) {
      console.error('Failed to update payment:', err);
      setError('Failed to update payment. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };



  useEffect(() => {
    if (orderId  && allSet) {
      const timer = setTimeout(() => {
        updatePaymentInBackend();
      }, 100); // Small delay to avoid too frequent updates

      return () => clearTimeout(timer);
    }
  }, [orderId, allSet, totalPayAmount]);


  return (
    <div>
      {/* <h2>Order ID: {orderId}</h2> */}

      <div className="bg-blue-100 flex flex-col gap-5 pt-10 min-h-screen">
        <div className="flex flex-row justify-between w-[97%] mx-auto gap-5">
          <div className="h-[410px]  w-[40%] bg-white rounded-xl">
            <div className="flex flex-col gap-6 p-5">
              <div className="flex flex-row justify-between">
                <h1 className="font-roboto text-xl text-gray-800 font-semibold">
                  Contact
                </h1>
                <button onClick={openModalEditContact}>
                  <div className="rounded-full p-2 bg-gray-100">
                    <img
                      className="w-6 h-6"
                      alt=""
                      src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZlcnNpb249IjEuMSIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHdpZHRoPSI1MTIiIGhlaWdodD0iNTEyIiB4PSIwIiB5PSIwIiB2aWV3Qm94PSIwIDAgNTEyIDUxMiIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgNTEyIDUxMiIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+PGc+PHBhdGggZD0iTTQ0Ni45NjcgMjIuMDQ4YTY4LjAyNCA2OC4wMjQgMCAwIDAtOTYuMDg5IDBMNDEuOTA5IDMzMS4wMTlhMTUuOTgxIDE1Ljk4MSAwIDAgMC00LjIyNCA3LjVMLjQ2MiA0ODkuOTkzQTE2IDE2IDAgMCAwIDE5LjMgNTA5LjQ2N2wxNTUuODU3LTMyLjg0M2ExNiAxNiAwIDAgMCA4LjAxNS00LjM0M2wzMDguOTctMzA4Ljk3YTY4LjA0NiA2OC4wNDYgMCAwIDAgMC05Ni4wODl6TTEzNy42ODIgMzk5LjEzNSAzNDkuNjEzIDE4Ny4ybDM2LjY5IDM2LjY5LTIxMS45MzEgMjExLjkzNXptLTU5LjMxOC01OS4zMTdMMjkwLjMgMTI3Ljg4N2wzNi42OSAzNi42OS0yMTEuOTM2IDIxMS45MzF6bTIzNC41NTgtMjM0LjU1OSAxOS43NjgtMTkuNzY4TDQyOC43IDE4MS41bC0xOS43NyAxOS43Njd6TTYyLjk3NyAzNjkuNjg1bDgwLjg0IDgwLjg0LTEwNi4yIDIyLjM4em00MDYuNTM2LTIyOS0xOC4xODggMTguMTg3LTk2LjAwNy05Ni4wMDggMTguMTg3LTE4LjE4OGEzNS45ODYgMzUuOTg2IDAgMCAxIDUwLjgzNCAwbDQ1LjE3NCA0NS4xNzRhMzYuMDQ2IDM2LjA0NiAwIDAgMSAwIDUwLjgzNHoiIGZpbGw9IiMwMDAwMDAiIG9wYWNpdHk9IjEiIGRhdGEtb3JpZ2luYWw9IiMwMDAwMDAiPjwvcGF0aD48L2c+PC9zdmc+"
                    />
                  </div>
                </button>
              </div>
              <h1 className="text-lg font-roboto text-gray-600">
                <span className="text-gray-900">Name:</span>{" "}
                {products.firstName} {products.lastName}
              </h1>
              <h1 className="text-lg font-roboto text-gray-500">
                <span className="text-gray-900">Phone Number:</span>{" "}
                {products.phoneNumber}
              </h1>
              <h1 className="text-lg font-roboto text-gray-500">
                <span className="text-gray-900">Email Address:</span>{" "}
                <span className="text-blue-500">{products?.email}</span>
              </h1>
              <form onSubmit={handleSubmit}>
                <div className="flex flex-row gap-2 w-full items-center">
                  <label
                    htmlFor="subject"
                    className="text-gray-900 font-roboto text-lg "
                  >
                    Subject:
                  </label>
                  <input
                    type="text"
                    id="subject"
                    className="text-gray-900 w-full font-roboto text-md border border-gray-400 rounded ml-4"
                    value={emailData.subject}
                    onChange={(e) =>
                      setEmailData({
                        ...emailData,
                        subject: e.target.value,
                      })
                    }
                    required
                  />
                </div>

                <div className="flex flex-row gap-5 items-center">
                  <button
                    className="text-sm font-roboto px-4 py-2 bg-blue-600 text-white my-4 rounded"
                    type="submit"
                    disabled={loading}
                  >
                    {loading ? "Sending..." : "Send Invoice"}
                  </button>
                  <Link
                    className="text-blue-500 font-roboto text-md hover:border-b hover:border-b-blue-500"
                    to={`/invoice/view-invoice/${products._id}`}
                  >
                    Invoice Link
                  </Link>
                  <Link
                    className="text-blue-500 font-roboto text-md hover:border-b hover:border-b-blue-500"
                    to={`/pullSheet/view-pullSheet/${products._id}`}
                  >
                    Pull sheet
                  </Link>
                </div>
              </form>
              <h1 className="text-lg font-roboto text-gray-600">
                <strong>Issue Date : </strong>
                {new Date(products.createdAt).toLocaleString("en-US", {
                  month: "short",
                  day: "numeric",
                  year: "numeric",
                  hour: "numeric",
                  minute: "2-digit",
                  hour12: true,
                })}
              </h1>
            </div>
          </div>
          <div className="h-[410px] w-[60%] rounded-xl flex flex-row justify-between bg-white">
            <div className="flex flex-col w-[40%] gap-2 p-5">
              <div className="flex flex-row justify-between">
                <h1 className="font-roboto text-xl text-gray-900 font-semibold">
                  Venue
                </h1>
                <button onClick={openModalEditVenue}>
                  <div className="rounded-full p-2 bg-gray-100">
                    <img
                      className="w-6 h-6"
                      alt=""
                      src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZlcnNpb249IjEuMSIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHdpZHRoPSI1MTIiIGhlaWdodD0iNTEyIiB4PSIwIiB5PSIwIiB2aWV3Qm94PSIwIDAgNTEyIDUxMiIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgNTEyIDUxMiIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+PGc+PHBhdGggZD0iTTQ0Ni45NjcgMjIuMDQ4YTY4LjAyNCA2OC4wMjQgMCAwIDAtOTYuMDg5IDBMNDEuOTA5IDMzMS4wMTlhMTUuOTgxIDE1Ljk4MSAwIDAgMC00LjIyNCA3LjVMLjQ2MiA0ODkuOTkzQTE2IDE2IDAgMCAwIDE5LjMgNTA5LjQ2N2wxNTUuODU3LTMyLjg0M2ExNiAxNiAwIDAgMCA4LjAxNS00LjM0M2wzMDguOTctMzA4Ljk3YTY4LjA0NiA2OC4wNDYgMCAwIDAgMC05Ni4wODl6TTEzNy42ODIgMzk5LjEzNSAzNDkuNjEzIDE4Ny4ybDM2LjY5IDM2LjY5LTIxMS45MzEgMjExLjkzNXptLTU5LjMxOC01OS4zMTdMMjkwLjMgMTI3Ljg4N2wzNi42OSAzNi42OS0yMTEuOTM2IDIxMS45MzF6bTIzNC41NTgtMjM0LjU1OSAxOS43NjgtMTkuNzY4TDQyOC43IDE4MS41bC0xOS43NyAxOS43Njd6TTYyLjk3NyAzNjkuNjg1bDgwLjg0IDgwLjg0LTEwNi4yIDIyLjM4em00MDYuNTM2LTIyOS0xOC4xODggMTguMTg3LTk2LjAwNy05Ni4wMDggMTguMTg3LTE4LjE4OGEzNS45ODYgMzUuOTg2IDAgMCAxIDUwLjgzNCAwbDQ1LjE3NCA0NS4xNzRhMzYuMDQ2IDM2LjA0NiAwIDAgMSAwIDUwLjgzNHoiIGZpbGw9IiMwMDAwMDAiIG9wYWNpdHk9IjEiIGRhdGEtb3JpZ2luYWw9IiMwMDAwMDAiPjwvcGF0aD48L2c+PC9zdmc+"
                    />
                  </div>
                </button>
              </div>

              <h1 className="text-md font-roboto text-gray-500">
                <span className="text-gray-900">Address :</span>{" "}
                {products.address}
              </h1>

              <h1 className="text-md font-roboto text-gray-500">
                <span className="text-gray-900">City :</span> {products.city}
              </h1>

              <h1 className="text-md font-roboto text-gray-500">
                <span className="text-gray-900">State :</span> {products.state}
              </h1>
              <h1 className="text-md font-roboto text-gray-500">
                <span className="text-gray-900">Zip Code :</span>{" "}
                {products.postCode}
              </h1>

              <h1 className="text-md font-roboto text-gray-500 w-full h-10  overflow-auto">
                <span className="text-gray-900">Notes :</span>{" "}
                {products.VenueNotes}
              </h1>
            </div>
            <div className="w-[60%]">
              <iframe
                width="100%"
                height="400"
                style={{ border: 0 }}
                loading="lazy"
                allowFullScreen
                referrerPolicy="no-referrer-when-downgrade"
                src={`https://www.google.com/maps?q=${encodeURIComponent(
                  `${products.address}, ${products.city}, ${products.state}, ${products.postCode}`
                )}&t=m&z=15&ie=UTF8&iwloc=&output=embed`}
              ></iframe>
            </div>
          </div>
        </div>
        <div className="flex justify-start mx-10"></div>

        <div className="w-[97%] mx-auto h-[250px] gap-6 bg-white flex flex-row p-6 rounded-xl shadow-lg">
          {/* Left Section: Project Notes */}
          <div className="w-[60%] flex flex-col gap-4">
            <div className="flex flex-row justify-between items-center">
              <h1 className="font-roboto text-xl font-bold text-gray-900">
                Project Notes
              </h1>
              <button
                onClick={openModalEditNotes}
                className="p-2 rounded-full hover:bg-gray-100 transition-colors duration-200"
              >
                <img
                  className="w-6 h-6"
                  alt="Edit Notes"
                  src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZlcnNpb249IjEuMSIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHdpZHRoPSI1MTIiIGhlaWdodD0iNTEyIiB4PSIwIiB5PSIwIiB2aWV3Qm94PSIwIDAgNTEyIDUxMiIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgNTEyIDUxMiIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+PGc+PHBhdGggZD0iTTQ0Ni45NjcgMjIuMDQ4YTY4LjAyNCA2OC4wMjQgMCAwIDAtOTYuMDg5IDBMNDEuOTA5IDMzMS4wMTlhMTUuOTgxIDE1Ljk4MSAwIDAgMC00LjIyNCA3LjVMLjQ2MiA0ODkuOTkzQTE2IDE2IDAgMCAwIDE5LjMgNTA5LjQ2N2wxNTUuODU3LTMyLjg0M2ExNiAxNiAwIDAgMCA4LjAxNS00LjM0M2wzMDguOTctMzA4Ljk3YTY4LjA0NiA2OC4wNDYgMCAwIDAgMC05Ni4wODl6TTEzNy42ODIgMzk5LjEzNSAzNDkuNjEzIDE4Ny4ybDM2LjY5IDM2LjY5LTIxMS45MzEgMjExLjkzNXptLTU5LjMxOC01OS4zMTdMMjkwLjMgMTI3Ljg4N2wzNi42OSAzNi42OS0yMTEuOTM2IDIxMS45MzF6bTIzNC41NTgtMjM0LjU1OSAxOS43NjgtMTkuNzY4TDQyOC43IDE4MS41bC0xOS43NyAxOS43Njd6TTYyLjk3NyAzNjkuNjg1bDgwLjg0IDgwLjg0LTEwNi4yIDIyLjM4em00MDYuNTM2LTIyOS0xOC4xODggMTguMTg3LTk2LjAwNy05Ni4wMDggMTguMTg3LTE4LjE4OGEzNS45ODYgMzUuOTg2IDAgMCAxIDUwLjgzNCAwbDQ1LjE3NCA0NS4xNzRhMzYuMDQ2IDM2LjA0NiAwIDAgMSAwIDUwLjgzNHoiIGZpbGw9IiMwMDAwMDAiIG9wYWNpdHk9IjEiIGRhdGEtb3JpZ2luYWw9IiMwMDAwMDAiPjwvcGF0aD48L2c+PC9zdmc+"
                />
              </button>
            </div>
            <div className="flex-1">
              {products?.projectNotes ? (
                <div className="w-full bg-gray-50 rounded-lg p-4 overflow-y-auto h-[150px] border border-gray-200">
                  <p className="text-sm font-roboto text-gray-700 leading-6">
                    {products?.projectNotes}
                  </p>
                </div>
              ) : (
                <div className="w-full h-[150px] flex items-center justify-center bg-gray-50 rounded-lg border border-gray-200">
                  <h1 className="text-gray-400 font-roboto text-sm">
                    No notes available
                  </h1>
                </div>
              )}
            </div>
          </div>

          {/* Right Section: Image Gallery */}
          <div className="w-[40%] flex flex-row gap-4 overflow-x-auto">
            <ModalImageGallary images={images}></ModalImageGallary>
            {/* {images.map((image, index) => (
      <div
        key={index}
        className="relative w-44 h-48 flex-shrink-0 border rounded-lg overflow-hidden shadow-sm hover:shadow-md transition-shadow duration-200"
      >
        <img
          src={typeof image === "string" ? image : URL.createObjectURL(image)}
          alt={`preview-${index}`}
          className="object-cover w-full h-full"
        />
      </div>
    ))} */}
          </div>
        </div>
        {Array.isArray(allSet) && allSet.length > 0 ? (
          allSet.map((perSet, index) => (
            <div
              key={index}
              className=" bg-white  border rounded-lg w-[97%] mx-auto "
            >
              <div className="bg-blue-500 px-6 py-4 rounded-t-lg flex flex-row items-center justify-between">
                <div className="flex flex-col text-white gap-2 ">
                  <p className="text-xl font-roboto font-semibold">
                    {perSet.setTitle}
                  </p>
                  <p className="text-md font-roboto ">
                    Start Date:{" "}
                    {perSet.startDate === "" ? (
                      "TBD"
                    ) : (
                      <span>
                        {new Date(perSet.startDate).toLocaleString("en-US", {
                          month: "short",
                          day: "numeric",
                          year: "numeric",
                          hour: "numeric",
                          minute: "2-digit",
                          hour12: true,
                        })}
                      </span>
                    )}{" "}
                    {/* Display start date and time */}
                    <span className="font-roboto font-light mx-2">To</span> End
                    Date:{" "}
                    {perSet.startDate === "" ? (
                      "TBD"
                    ) : (
                      <span>
                        {new Date(perSet.endDate).toLocaleString("en-US", {
                          month: "short",
                          day: "numeric",
                          year: "numeric",
                          hour: "numeric",
                          minute: "2-digit",
                          hour12: true,
                        })}
                      </span>
                    )}{" "}
                    {/* Display end date and time */}
                  </p>
                </div>
                <div className="flex flex-row gap-5">
                  <div className="grid grid-cols-2 gap-2">
                    <button
                      onClick={() => {
                        // setSelectedSet({
                        //   ...perSet,
                        //   setCode: perSet.setCode,
                        //   orderId: perSet.orderId,
                        // });
                        setSelectedSetCode(perSet.setCode);
                        setIsAddTearDownModalOpen(true);
                      }}
                      className="bg-blue-800 font-roboto text-md hover:bg-blue-900 text-white px-4 py-2 rounded flex items-center justify-center space-x-2 transition duration-300"
                    >
                      <FaPlus className="text-sm" /> {/* Add icon */}
                      <span>Add Setup/Teardown Fees</span>
                    </button>
                    <button
                      onClick={() => {
                        // setSelectedSet({
                        //   ...perSet,
                        //   setCode: perSet.setCode,
                        //   orderId: perSet.orderId,
                        // });
                        setSelectedSetCode(perSet.setCode);
                        setIsAddDeliveryModalOpen(true);
                      }}
                      className="bg-blue-800 font-roboto text-md hover:bg-blue-900 text-white px-4 py-2 rounded flex items-center justify-center space-x-2 transition duration-300"
                    >
                      <FaPlus className="text-sm" /> {/* Add icon */}
                      <span>Add Delivery</span>
                    </button>
                    <button
                      onClick={() => {
                        setSelectedSetCode(perSet.setCode);
                        setIsAddProductModalOpen(true);
                      }}
                      className="bg-blue-800 font-roboto text-md hover:bg-blue-900 text-white px-4 py-2 rounded flex items-center justify-center space-x-2 transition duration-300"
                    >
                      <FaPlus className="text-sm" /> {/* Add icon */}
                      <span>Add Custom Product</span>
                    </button>
                    <button
                      onClick={() => {
                        setSelectedSetCode(perSet.setCode);
                        setIsAddInventoryModalOpen(true);
                      }}
                      className="bg-blue-800 font-roboto text-md hover:bg-blue-900 text-white px-4 py-2 rounded flex items-center justify-center space-x-2 transition duration-300"
                    >
                      <FaBoxOpen className="text-sm" /> {/* Add icon */}
                      <span>Add Main Product</span>
                    </button>
                  </div>
                  <button
                    onClick={() => {
                      setSelectedSet(perSet, perSet.setCode);
                      setIsModalOpenSetUpdate(true);
                    }}
                    className="mx-10"
                  >
                    <img
                      className="w-8 h-8"
                      src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZlcnNpb249IjEuMSIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHdpZHRoPSI1MTIiIGhlaWdodD0iNTEyIiB4PSIwIiB5PSIwIiB2aWV3Qm94PSIwIDAgMjQgMjQiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDUxMiA1MTIiIHhtbDpzcGFjZT0icHJlc2VydmUiPjxnPjxnIGZpbGw9IiM0Mjk0ZmYiPjxjaXJjbGUgY3g9IjEyIiBjeT0iMTIiIHI9IjMiIGZpbGw9IiNmZmZmZmYiIG9wYWNpdHk9IjEiIGRhdGEtb3JpZ2luYWw9IiM0Mjk0ZmYiPjwvY2lyY2xlPjxjaXJjbGUgY3g9IjEyIiBjeT0iNSIgcj0iMyIgZmlsbD0iI2ZmZmZmZiIgb3BhY2l0eT0iMSIgZGF0YS1vcmlnaW5hbD0iIzQyOTRmZiI+PC9jaXJjbGU+PGNpcmNsZSBjeD0iMTIiIGN5PSIxOSIgcj0iMyIgZmlsbD0iI2ZmZmZmZiIgb3BhY2l0eT0iMSIgZGF0YS1vcmlnaW5hbD0iIzQyOTRmZiI+PC9jaXJjbGU+PC9nPjwvZz48L3N2Zz4="
                    />{" "}
                  </button>
                </div>
              </div>
              {/* Display products inside each set */}
              <div className="mt-2">
                <table class="w-full  text-left rtl:text-right  dark:text-gray-400">
                  <thead class="text-sm font-roboto text-gray-600 uppercase bg-gray-100 dark:bg-gray-700 dark:text-gray-400">
                    <tr>
                      {/* <th scope="col" class="px-6 py-3 "></th> */}
                      <th scope="col" class="px-6 py-3 ">
                        Item
                      </th>
                      <th scope="col" class="px-6 py-3">
                        Quantity
                      </th>
                      <th scope="col" class="px-6 py-3">
                        Price
                      </th>

                      <th scope="col" class="px-6 py-3 ">
                        Total
                      </th>
                      <th scope="col" className="px-6 py-3">
                        Discount
                      </th>
                      <th scope="col" className="px-6 py-3">
                        Tax
                      </th>

                      <th scope="col" class="px-6 py-3 ">
                        Sub Total
                      </th>
                      <th scope="col" className="px-6 py-3">
                        Actions
                      </th>
                    </tr>
                  </thead>
                  {perSet.products && perSet.products.length > 0 ? (
                    perSet.products.map((product, pIndex) => (
                      <tr
    className="border-b dark:bg-gray-800 dark:border-gray-700 bg-white hover:bg-gray-50 transition-colors"

  >
    {/* Drag Handle Column - made more prominent */}
    {/* <td className="px-2 py-4 text-md">
      <DragHandle />
    </td> */}

      {/* Image and Details */}
      <td className="px-6 py-4 text-md font-roboto text-gray-800 w-[500px]">
        <div className="flex flex-row gap-2">
          <div className="w-28 h-28">
            {product?.deliveryType === "delivery" ? (
              <img
                alt=""
                className="w-28 h-28 rounded object-cover"
                src="data:image/svg+xml;base64,..."
              />
            ) : product.singleImage ? (
              <img
                className="w-28 h-28 rounded object-cover"
                src={product.singleImage}
                alt="Product"
              />
            ) : (
              <img className="w-24 h-24" src={noImage} alt="No image" />
            )}
          </div>
          <div>
            <strong>{product?.title}</strong>
            {product?.deliveryType === "delivery" ||
            product?.deliveryType === "tear" ? (
              <h1>
                {product?.deliveryType === "tear" ? null : (
                  <>
                    Start Date:{" "}
                    {new Date(product.startDate).toLocaleString("en-US", {
                      month: "short",
                      day: "numeric",
                      year: "numeric",
                      hour: "numeric",
                      minute: "2-digit",
                      hour12: true,
                    })}
                  </>
                )}
              </h1>
            ) : (
              <h1>Product Code | {product.productCode}</h1>
            )}
          </div>
        </div>
        <div className="flex flex-col gap-2 w-full mt-2">
          <span className="text-justify">
            {/* <strong>Des</strong>: {product?.description} */}
            {product?.description ? (
                      <div
                        className="text-justify"
                        dangerouslySetInnerHTML={{
                          __html: product?.description,
                        }}
                      ></div>
                    ) : (
                      ""
                    )}
            
          </span>
          <span className="text-justify">
            {product?.color && /\d/.test(product.color)
              ? `Color: ${product.color}, `
              : ""}
            {product?.height && /\d/.test(product.height)
              ? `Height: ${product.height}, `
              : ""}
            {product?.length && /\d/.test(product.length)
              ? `Length: ${product.length}, `
              : ""}
            {product?.width && /\d/.test(product.width)
              ? `Width: ${product.width}, `
              : ""}
            {product?.shape && /\d/.test(product.shape)
              ? `Shape: ${product.shape}`
              : ""}
          </span>
          <span className="text-justify">
            <strong>Notes</strong>: {product?.internalNotes}
          </span>
        </div>
      </td>

      {/* Quantity */}
      {product?.deliveryType === "delivery" ||
      product?.deliveryType === "tear" ? (
        <td></td>
      ) : (
        <td className="px-6 py-4 text-md font-roboto text-gray-800">
          {product?.quantity}
        </td>
      )}

      {/* Discount Price */}
      {product?.deliveryType === "delivery" ? (
        <td></td>
      ) : (
        <td className="px-6 py-4 text-md font-roboto text-gray-800">
          <div className="flex flex-col">
            <span>{calculateDiscountSelectedPrice(product)}</span>
            {product.discount && (
              <del className="mt-1">{product?.selectedPricingValue}</del>
            )}
          </div>
        </td>
      )}

      {/* With Discount Price */}
      <td className="px-6 py-4 text-md font-roboto text-gray-800">
        <div>{calculateWithDiscountPrice(product)}</div>
        {product.discount && product.discount !== "0" ? (
  <span>
    <del className="mt-1">{calculateSingleTotalPrice(product)}</del>
  </span>
) : null}
        
      </td>

      {/* Discount Info */}
      <td className="px-6 py-4 text-md font-roboto text-gray-800">
        <div className="flex flex-col gap-1">
          <span>
            {product?.discount &&
              (product?.discountType === "$" ? (
                <>
                  {product?.discountType}
                  {product?.discount}
                </>
              ) : (
                <>
                  {product?.discount}
                  {product?.discountType}
                </>
              ))}
          </span>
          {product?.discount && (
            <span className="text-sm text-red-600">
              $ ({calculateProductDiscountPrice(product)})
            </span>
          )}
        </div>
      </td>

      {/* Tax Info */}
      <td className="px-2 py-4 text-md font-roboto text-gray-800">
        {product?.tax && (
          <div className="flex flex-col items-center">
            <span>{product?.tax} %</span>
            <span className="text-red-600 text-sm">
              ($ {calculateTotalTaxAmount(product)})
            </span>
          </div>
        )}
      </td>

      {/* Final Price */}
      <td className="px-6 py-4 text-md font-roboto text-gray-800">
        {product?.discount || product?.tax ? (
          <span>{calculateTotalPrice(product)}</span>
        ) : (
          <span>
            {(product.quantity * product.selectedPricingValue).toFixed(2)}
          </span>
        )}
      </td>

      {/* Actions */}
      <td
        className="px-6 py-4 text-md font-roboto text-gray-800"
        onClick={(e) => {
          // Prevent drag initiation when clicking on actions
          e.stopPropagation();
          e.preventDefault();
        }}
      >
        <DropdownAction
          onActionClick={() => handleActionProduct(product, perSet.setCode)}
          onEditClick={() => handleEditProduct(product, perSet.setCode)}
        ></DropdownAction>
      </td>
    </tr>
                    ))
                  ) : (
                    <p>No products in this set.</p>
                  )}
                </table>
              </div>
              <div className="w-full flex justify-between px-10">
                <div className="mt-4 w-96 h-56 "></div>
                <div className="mt-4 w-96 h-56 bg-gray-50 rounded-lg  p-6 font-roboto">
                  <h1 className="text-lg font-semibold text-gray-700 mb-2">
                    Sub Total:{" "}
                    <span className="float-right">
                      ${calculateSetSubTotal(perSet.products)}
                    </span>
                  </h1>

                  <h1 className="text-lg font-semibold text-gray-700 mb-2">
                    Discount Total:{" "}
                    <span className="float-right text-red-600">
                      - ${calculateAllDiscountTotal(perSet.products)}
                    </span>
                  </h1>
                  <h1 className="text-lg font-semibold text-gray-700 mb-2">
                    Tax Total:{" "}
                    <span className="float-right">
                      ${calculateTaxTotal(perSet.products)}
                    </span>
                  </h1>
                  <hr className="my-3 border-gray-300" />
                  <h1 className="text-xl font-bold text-gray-900">
                    Total:{" "}
                    <span className="float-right">
                      ${calculateSetTotal(perSet.products)}
                    </span>
                  </h1>
                </div>
              </div>
              <button
                onClick={() => handleDeleteSet(perSet.setCode)}
                className="mt-6 mb-2 font-roboto text-md  text-red-500 hover:border-b hover:border-b-red-500 mx-6 duration-300"
              >
                Delete Group
              </button>
            </div>
          ))
        ) : (
          <div>No sets available</div>
        )}

        <div className="my-2 w-full flex gap-5 justify-center items-center rounded-lg ">
          <button
            onClick={() => setIsAddNewSetModalOpen(true)}
            className="bg-blue-500 text-white px-4 py-2 rounded flex flex-row gap-4 items-center font-roboto text-xl"
          >
            <FaPlus className="text-sm" /> Add Line Item Group
          </button>
          <button
            onClick={() => setAddTermsConditionsOpen(true)}
            className="bg-blue-900 text-white px-4 py-2 rounded flex flex-row gap-4 items-center font-roboto text-xl"
          >
            <FaPlus className="text-sm" /> Add Terms and Conditions
          </button>
        </div>

        <div className="w-[97%] mx-auto flex justify-between p-5 ">
          <div className="w-[500px] rounded-lg">
            {paymentData.length > 0 ? (
              <div className="w-full ">
                {/* const paid amount start*/}
                <button
                  className="text-xl mb-4 flex items-center gap-4 font-roboto text-gray-900 bg-gray-50 shadow-sm rounded px-6 py-2"
                  onClick={() => openModalDeposit()}
                >
                  <img
                    className="w-5 h-5"
                    alt=""
                    src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZlcnNpb249IjEuMSIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHdpZHRoPSI1MTIiIGhlaWdodD0iNTEyIiB4PSIwIiB5PSIwIiB2aWV3Qm94PSIwIDAgNTEyIDUxMiIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgNTEyIDUxMiIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSIgY2xhc3M9IiI+PGc+PHBhdGggZD0iTTQ5MiAyMzZIMjc2VjIwYzAtMTEuMDQ2LTguOTU0LTIwLTIwLTIwcy0yMCA4Ljk1NC0yMCAyMHYyMTZIMjBjLTExLjA0NiAwLTIwIDguOTU0LTIwIDIwczguOTU0IDIwIDIwIDIwaDIxNnYyMTZjMCAxMS4wNDYgOC45NTQgMjAgMjAgMjBzMjAtOC45NTQgMjAtMjBWMjc2aDIxNmMxMS4wNDYgMCAyMC04Ljk1NCAyMC0yMHMtOC45NTQtMjAtMjAtMjB6IiBmaWxsPSIjNTk1NzU3IiBvcGFjaXR5PSIxIiBkYXRhLW9yaWdpbmFsPSIjMDAwMDAwIj48L3BhdGg+PC9nPjwvc3ZnPg=="
                  />
                  Add advance deposit ( % )
                </button>
                <div className="w-full bg-white">
                  {paymentData.length > 0 ? (
                    <div className="bg-white border border-gray-300  shadow-lg p-5">
                      <h1 className="text-xl font-roboto text-gray-500">
                        Payment received{" "}
                      </h1>
                      <div className="flex flex-col gap-5 mt-4  h-[400px] overflow-auto">
                        {paymentData.map((payment, index) => (
                          <div className="bg-gray-100 p-4 rounded" key={index}>
                            <p className="font-roboto text-xl text-gray-700">
                              <strong>Amount:</strong> ${payment.payAmount}
                            </p>
                            {payment?.paymentMethod ? (
                              <p className="font-roboto text-md text-gray-700">
                                <strong>Payment Method :</strong>{" "}
                                {payment?.paymentMethod}
                              </p>
                            ) : (
                              <div>
                                <p className="font-roboto text-md text-gray-700">
                                  <strong>Payment Method :</strong> Stripe
                                </p>

                                <p className="font-roboto text-md text-gray-700">
                                  <strong>Stripe ID:</strong>{" "}
                                  {payment.stripePaymentId}
                                </p>
                              </div>
                            )}
                            {payment?.PaymentDate ? (
                              <p className="font-roboto text-sm text-gray-700">
                                <strong>Payment Date:</strong>{" "}
                                {new Date(payment.PaymentDate).toLocaleString(
                                  "en-US",
                                  {
                                    month: "short",
                                    day: "numeric",
                                    year: "numeric",
                                    hour: "numeric",
                                    minute: "2-digit",
                                    hour12: true,
                                  }
                                )}
                              </p>
                            ) : (
                              <p className="font-roboto text-sm text-gray-700">
                                <strong>Payment Date:</strong>{" "}
                                {new Date(payment.createdAt).toLocaleString(
                                  "en-US",
                                  {
                                    month: "short",
                                    day: "numeric",
                                    year: "numeric",
                                    hour: "numeric",
                                    minute: "2-digit",
                                    hour12: true,
                                  }
                                )}
                              </p>
                            )}
                          </div>
                        ))}
                      </div>
                    </div>
                  ) : (
                    ""
                  )}
                </div>
                {/* const paid amount end*/}
              </div>
            ) : (
              <div className="flex flex-col gap-5">
                <button
                  className="text-xl flex items-center gap-4 font-roboto text-gray-900 bg-gray-50 shadow-sm rounded px-6 py-2"
                  onClick={() => openModalDiscount()}
                >
                  <img
                    className="w-5 h-5"
                    alt=""
                    src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZlcnNpb249IjEuMSIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHdpZHRoPSI1MTIiIGhlaWdodD0iNTEyIiB4PSIwIiB5PSIwIiB2aWV3Qm94PSIwIDAgNTEyIDUxMiIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgNTEyIDUxMiIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSIgY2xhc3M9IiI+PGc+PHBhdGggZD0iTTQ5MiAyMzZIMjc2VjIwYzAtMTEuMDQ2LTguOTU0LTIwLTIwLTIwcy0yMCA4Ljk1NC0yMCAyMHYyMTZIMjBjLTExLjA0NiAwLTIwIDguOTU0LTIwIDIwczguOTU0IDIwIDIwIDIwaDIxNnYyMTZjMCAxMS4wNDYgOC45NTQgMjAgMjAgMjBzMjAtOC45NTQgMjAtMjBWMjc2aDIxNmMxMS4wNDYgMCAyMC04Ljk1NCAyMC0yMHMtOC45NTQtMjAtMjAtMjB6IiBmaWxsPSIjNTk1NzU3IiBvcGFjaXR5PSIxIiBkYXRhLW9yaWdpbmFsPSIjMDAwMDAwIj48L3BhdGg+PC9nPjwvc3ZnPg=="
                  />
                  Add discount on total
                </button>
                <button
                  className="text-xl flex items-center gap-4 font-roboto text-gray-900 bg-gray-50 shadow-sm rounded px-6 py-2"
                  onClick={() => openModalDeposit()}
                >
                  <img
                    className="w-5 h-5"
                    alt=""
                    src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZlcnNpb249IjEuMSIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHdpZHRoPSI1MTIiIGhlaWdodD0iNTEyIiB4PSIwIiB5PSIwIiB2aWV3Qm94PSIwIDAgNTEyIDUxMiIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgNTEyIDUxMiIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSIgY2xhc3M9IiI+PGc+PHBhdGggZD0iTTQ5MiAyMzZIMjc2VjIwYzAtMTEuMDQ2LTguOTU0LTIwLTIwLTIwcy0yMCA4Ljk1NC0yMCAyMHYyMTZIMjBjLTExLjA0NiAwLTIwIDguOTU0LTIwIDIwczguOTU0IDIwIDIwIDIwaDIxNnYyMTZjMCAxMS4wNDYgOC45NTQgMjAgMjAgMjBzMjAtOC45NTQgMjAtMjBWMjc2aDIxNmMxMS4wNDYgMCAyMC04Ljk1NCAyMC0yMHMtOC45NTQtMjAtMjAtMjB6IiBmaWxsPSIjNTk1NzU3IiBvcGFjaXR5PSIxIiBkYXRhLW9yaWdpbmFsPSIjMDAwMDAwIj48L3BhdGg+PC9nPjwvc3ZnPg=="
                  />
                  Add advance deposit ( % )
                </button>
              </div>
            )}
          </div>
          <div className="w-[400px]  bg-white border border-gray-200 rounded-lg shadow-lg ">
            <div className="px-6 py-4 border-b border-gray-800 flex flex-row justify-between">
              <h1 className="font-roboto text-xl text-gray-600 font-semibold">
                Totals
              </h1>
            </div>
            <div className="p-6">
              <h1 className="text-lg font-semibold text-gray-800 flex justify-between mt-4 mb-2">
                Sub Total: <span>${calculateAllSetSubTotal(allSet)}</span>
              </h1>
              <h1 className="text-lg font-semibold text-gray-800 flex justify-between mb-2 border-t pt-2">
                Discount:{" "}
                <span className="text-red-600">
                  - ${calculateAllSetDiscount(allSet)}
                </span>
              </h1>
              <h1 className="text-lg font-semibold text-gray-800 flex justify-between mb-2 border-t pt-2">
                Tax: <span>${calculateAllSetTax(allSet)}</span>
              </h1>
              <h1 className="text-lg font-semibold text-gray-800 flex justify-between mt-4 border-t pt-2">
                Total: <span>${calculateAllSetTotal(allSet)}</span>
              </h1>
              <h1 className="text-lg font-semibold text-gray-800 flex justify-between mt-4 border-t pt-2">
                Discount on Total:{" "}
                <span>
                  {products?.AllProductDiscount}{" "}
                  {products?.AllProductDiscountType}
                </span>
              </h1>
              <h1 className="text-lg font-semibold text-gray-800 flex justify-between mt-4 border-t pt-2">
                Final Total:{" "}
                <span>${calculateFinalTotal(allSet, products)}</span>
              </h1>

              <h1 className="text-lg font-semibold text-gray-800 flex justify-between mt-4 border-t pt-2">
                Deposit ({products?.advanceDepositValue}{" "}
                {products?.advanceDepositType}):{" "}
                <span>
                  ${" "}
                  {calculateDeposit(
                    calculateFinalTotal(allSet, products),
                    products?.advanceDepositValue,
                    products?.advanceDepositType
                  )}
                </span>
              </h1>
              <h1 className="text-lg font-semibold text-gray-800 flex justify-between mt-4 border-t pt-2">
                Amount Paid :<span>$ {totalPayAmount}</span>
              </h1>
              <h1 className="text-lg font-semibold text-gray-800 flex justify-between mt-4 border-t pt-2">
                Amount Due :<span>$ {amountDue}</span>
              </h1>
            </div>
          </div>
        </div>
        <div className="w-[97%] p-5  bg-white mx-auto mb-10 rounded-xl">
          <h2 className="text-lg font-semibold text-gray-800 mb-4">
            Selected Terms And Conditions:
          </h2>
          <div
            className="prose prose-blue max-w-none"
            dangerouslySetInnerHTML={{ __html: renderSelectedContent() }}
          />
        </div>
      </div>

      {/* Add New Set Modal */}
      <AddNewSetModal
        isOpen={isAddNewSetModalOpen}
        onClose={() => setIsAddNewSetModalOpen(false)}
        onAddSet={handleAddSet}
        newSetTitle={newSetTitle}
        setNewSetTitle={setNewSetTitle}
        startDate={startDate}
        setStartDate={setStartDate}
        endDate={endDate}
        setEndDate={setEndDate}
      />

      <AddTermsConditionsModal
        isOpen={isAddTermsConditionsOpen}
        onClose={() => setAddTermsConditionsOpen(false)}
        orderId={orderId}
        products={products}
      />
      {/* Add New Set Section */}
      {/* <div className="mt-4 p-4 bg-gray-100 rounded-lg">
        <h3 className="mb-2 font-bold">Add a New Set</h3>
        <input
          type="text"
          value={newSetTitle}
          onChange={(e) => setNewSetTitle(e.target.value)}
          placeholder="Enter new set title"
          className="border p-2 mr-2 rounded"
        />
        <DatePicker
          selected={startDate}
          onChange={(date) => setStartDate(date)}
          placeholderText="Start Date"
          className="border p-2 mr-2 rounded"
        />
        <DatePicker
          selected={endDate}
          onChange={(date) => setEndDate(date)}
          placeholderText="End Date"
          className="border p-2 rounded"
        />
        <button
          onClick={handleAddSet}
          className="bg-blue-500 text-white px-4 py-2 ml-2 rounded"
        >
          Add New Set
        </button>
      </div> */}

      {/* Edit Product Modal */}
      <EditProductModal
        isOpen={modalEditOpen}
        onClose={() => setModalEditOpen(false)}
        product={selectedProduct}
        editProduct={editProduct}
        handleEditChange={handleEditChange}
        handleUpdateEditProduct={handleUpdateEditProduct}
        setCode={MainSelectedSetCode}
        productCode={MainSelectedProductCode}
        singleImage={singleImage}
        setSingleImage={setSingleImage}
        isDragging={isDragging}
        handleDragOver={handleDragOver}
        handleDragLeave={handleDragLeave}
        handleDrop={handleDrop}
        handleFileChange={handleFileChange}
        description={editProduct.description}
        internalNotes={editProduct.internalNotes}
        selectedPricingValue={editProduct.selectedPricingValue}
      />
      <ActionProductModal
        isOpen={modalOpen}
        onClose={() => setModalOpen(false)}
        product={selectedProduct}
        actionProduct={actionProduct}
        handleChange={handleChange}
        handleUpdateProduct={handleUpdateProduct}
        setCode={MainSelectedSetCode}
        productCode={MainSelectedProductCode}
        handleDeleteProduct={handleDeleteProduct}
      ></ActionProductModal>

      <AddCustomProductModal
        isOpen={isAddProductModalOpen}
        onClose={() => setIsAddProductModalOpen(false)}
        onAddProduct={(setCode, newProduct) =>
          handleAddProductToSetCustom(orderId, setCode, newProduct)
        }
        setCode={selectedSetCode}
      />
      <AddDeliveryChargesModal
        isOpen={isAddDeliveryModalOpen}
        onClose={() => setIsAddDeliveryModalOpen(false)}
        onAddProduct={handleAddProductToSet}
        setCode={selectedSetCode}
      />
      <AddTearDownFees
        isOpen={isAddTearDownModalOpen}
        onClose={() => setIsAddTearDownModalOpen(false)}
        onAddProduct={handleAddProductToSet}
        setCode={selectedSetCode}
        twentyPercentTotal={twentyPercentTotal}
      ></AddTearDownFees>

      <AddInventoryProductModal
        isOpen={isAddInventoryModalOpen}
        onClose={() => setIsAddInventoryModalOpen(false)}
        onAddProduct={handleAddProductToSet}
        setCode={selectedSetCode}
      />
      <ModalTotalDiscount
        isVisible={IsDiscount}
        onClose={closeModalDiscount}
        orderId={products._id}
      ></ModalTotalDiscount>
      <ModalAddDeposit
        isVisible={IsDeposit}
        onClose={closeModalDeposit}
        orderId={products._id}
      ></ModalAddDeposit>

      <ModalEditOrderContact
        isVisible={isDropdownEditContact}
        onClose={closeModalEditContact}
        orderId={products._id}
        products={products}
      ></ModalEditOrderContact>
      <ModalEditOrderVenue
        isVisible={isDropdownEditVenue}
        onClose={closeModalEditVenue}
        orderId={products._id}
        products={products}
      ></ModalEditOrderVenue>
      <ModalAddNotes
        isVisible={isDropdownEditNotes}
        onClose={closeModalEditNotes}
        orderId={products._id}
        products={products}
      ></ModalAddNotes>
      {selectedSet && (
        <UpdateSetModal
          isOpen={isModalOpenSetUpdate}
          onClose={() => setIsModalOpenSetUpdate(false)}
          set={selectedSet}
          onUpdate={handleUpdateSet}
        />
      )}
    </div>
  );
};

export default OrderModify;
